import React from 'react';
import { formatCurrencyShort } from '@vanilla/utils/Utils.js';
import { PAYMENT_MODELS } from '@vanilla/constants/PaymentModels.js';
import DealSidebarActivities from './DealSidebarActivities.jsx';
import DealSidebarTimeline from './DealSidebarTimeline.jsx';

export default function DealFormRightSidebar({
    form,
    users,
    mentionUsers,
    sidebarTab,
    timelineFilter,
    openTimelineDrawer,
    highlightActivityId,
    contractValue,
    taxAmount,
    totalWithTax,
    commissionEstimate,
    commissionAssignedPct,
}) {
    return (
        <div className="deal-form-right-sidebar" id="dealRightSidebar">
            <DealSidebarActivities dealId={form.id} users={mentionUsers.length ? mentionUsers : users} initialTab={sidebarTab} highlightId={highlightActivityId} />

            <DealSidebarTimeline dealId={form.id} dealName={form.dealName} users={mentionUsers.length ? mentionUsers : users} initialFilter={timelineFilter} autoOpenDrawer={openTimelineDrawer} highlightId={highlightActivityId} />

            <div className="sidebar-card">
                <div className="sidebar-card-title">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
                    Revenue Summary
                </div>
                <div className="sidebar-summary-row">
                    <span className="sidebar-summary-label">Billing Amount</span>
                    <span className="sidebar-summary-value is-highlight" id="sidebarContractValue">{formatCurrencyShort(contractValue)}</span>
                </div>
                {form.taxIncluded && (
                    <div className="sidebar-summary-row" id="sidebarTaxAmountRow">
                        <span className="sidebar-summary-label">Tax</span>
                        <span className="sidebar-summary-value" id="sidebarTaxAmount">{formatCurrencyShort(taxAmount)}</span>
                    </div>
                )}
                {form.taxIncluded && (
                    <div className="sidebar-summary-row" id="sidebarTotalAmountRow">
                        <span className="sidebar-summary-label">Total Amount</span>
                        <span className="sidebar-summary-value is-highlight" id="sidebarTotalAmount">{formatCurrencyShort(totalWithTax)}</span>
                    </div>
                )}
                <div className="sidebar-summary-row">
                    <span className="sidebar-summary-label">Payment Model</span>
                    <span className="sidebar-summary-value" id="sidebarPaymentModel">{PAYMENT_MODELS.find((m) => m.value === form.dealPaymentModel)?.label || 'choose payment Model'}</span>
                </div>
                <div className="sidebar-summary-row">
                    <span className="sidebar-summary-label">Total Payments</span>
                    <span className="sidebar-summary-value" id="sidebarTotalPayments">{form.dealPaymentModel === 'one_time' ? 1 : (form.dealPaymentCount || 0)}</span>
                </div>
            </div>

            <div className="sidebar-card">
                <div className="sidebar-card-title">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" /></svg>
                    Commission Summary
                </div>
                <div className="sidebar-summary-row">
                    <span className="sidebar-summary-label">Estimated Commission</span>
                    <span className="sidebar-summary-value is-highlight" id="sidebarTotalCommission">{formatCurrencyShort(commissionEstimate)}</span>
                </div>
                <div className="sidebar-summary-row">
                    <span className="sidebar-summary-label">Recipients</span>
                    <span className="sidebar-summary-value" id="sidebarRecipientsCount">{(form.commissionSplits || []).filter((s) => s.userId).length}</span>
                </div>
                <div className="sidebar-summary-row">
                    <span className="sidebar-summary-label">Assigned</span>
                    <span className="sidebar-summary-value" id="sidebarTotalSplit">{commissionAssignedPct}%</span>
                </div>
            </div>
        </div>
    );
}
